import { ArrowLeft, ShieldX } from "lucide-react";
import { Link } from "react-router-dom";

export default function ErrorPage({ code = 404, title = "Pagina no encontrada", detail = "La ruta solicitada no existe." }) {
  return <main className="grid min-h-screen place-items-center bg-ink p-5 text-center"><div><ShieldX className="mx-auto text-barberRed" size={58}/><p className="mt-6 text-7xl font-black text-barberGold">{code}</p><h1 className="mt-2 text-2xl font-black uppercase">{title}</h1><p className="mt-2 text-zinc-500">{detail}</p><Link to={code === 403 ? "/pos" : "/login"} className="btn-primary mt-7"><ArrowLeft size={18}/> Volver</Link></div></main>;
}



